import {useState, useEffect} from 'react';
import type {TaskItemCounts} from '@/shared/notifications/getTaskItems';
import {getTaskItemCounts} from '@/shared/notifications/getTaskItemCounts';
import {isTeacherStore} from '@/shared/stores/isTeacherStore';
import type {MinervaSettings} from '@/shared/types/MinervaSettings';

export default function useTaskItemCounts(settings: MinervaSettings | null): TaskItemCounts {
    const [counts, setCounts] = useState<TaskItemCounts>({});
    useEffect(() => {
        if (
            !settings ||
            !settings.headers ||
            !settings.apiUrl ||
            !settings.classroomApiUrl ||
            !settings.idString
        )
            return;

        getTaskItemCounts(settings).then((result) => {
            if (result !== undefined) {
                setCounts(result);
            }
        });
    }, [
        settings?.headers,
        settings?.classroomEnabled,
        settings?.skillsEnabled,
        settings?.expertiseEnabled,
        settings?.evaluationEnabled,
        settings?.isAdmin,
        isTeacherStore.isTeacher,
    ]);

    return counts;
}
